import { render, staticRenderFns } from "./Familias.view.vue?vue&type=template&id=b668a1b0&"
import script from "./Familias.view.vue?vue&type=script&lang=js&"
export * from "./Familias.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports